import SteelcaseImage from "../layout/SteelcaseImage/SteelcaseImage";

interface MaterialCardProps {
    title: string;
    img: string;
    onClickHandler: () => void;
}

export default function MaterialCard({ img, title, onClickHandler }: MaterialCardProps) {
    return (
        <div className={"finish-material-card finish-material-card__container"} onClick={onClickHandler}>
            <div className={"finish-material-card__image-container"}>
                <SteelcaseImage className={"finish-material-card__image finish-material-card__image--aspect-ratio"} src={img} />
            </div>
            <span className={"finish-material-card__title"}>{title}</span>
        </div>
    )
}